module.exports = {
    appUrl: process.env.appUrl,
    apiUrl: process.env.apiUrl,
    mediaUrl: process.env.mediaUrl,
    mapApiKey: process.env.mapApiKey,
    stripe: {
        publishableKey: process.env.stripe.publishableKey
    }
};
